import DestinationsPage from "@/pages/destinations/DestinationsPage.tsx";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Destinations route definition
 */

export const Route = createFileRoute("/destinations")({
  component: DestinationsPage,
});
